/**
 * 🌐 TRADUCTIONS STATIQUES FRONTEND - PORTFOLIO WEBCRAFT
 * =====================================================
 * Fichier de traductions pour les éléments d'interface utilisateur uniquement
 * Les données de contenu (projets, formations, expériences) sont gérées côté backend
 * 
 */

export const translations = {
  fr: {
    // ================================
    // COOKIES ET RGPD
    // ================================
    cookies: {
      banner: {
        title: "✨ Oh, un cookie qui parle !",
        description: "Hey ! Moi c'est Cookie, le gardien du site. J'aide à rendre ta visite plus fun. On fait équipe ? 🤝"
      },
      actions: {
        acceptAll: "Adopte-moi ! 🎉",
        rejectAll: "Sans façon ! 🚫",
        customize: "On négocie ? 🤝",
        acceptSelected: "Tope là ! 🤜🤛"
      },
      required: "Cookie indispensable",
      optional: "Cookie bonus",
      links: {
        privacy: "Les coulisses 🎭",
        policy: "Mon histoire 📖"
      },
      categories: {
        necessary: {
          title: "Cookies essentiels",
          description: "Ces cookies sont nécessaires au bon fonctionnement du site. Ils ne peuvent pas être désactivés."
        },
        analytics: {
          title: "Cookies d'analyse",
          description: "Ces cookies m'aident à comprendre comment vous utilisez le site, de manière totalement anonyme."
        },
        marketing: {
          title: "Cookies marketing",
          description: "Ces cookies permettent d'afficher des publicités pertinentes. Je ne les utilise pas actuellement."
        }
      }
    },

    // ================================
    // navigation ET MENU
    // ================================
    menu: {
      home: "Accueil",
      about: "À propos",
      skills: "Compétences",
      projects: "Projets",
      education: "Formation",
      experience: "Expérience",
      contact: "Contact",
      services: "Services",
      cv: "CV",
      downloadCV: "Télécharger CV"
    },

    // ================================
    // HEADER ET HERO section
    // ================================
    header: {
      greeting: "Bonjour, je suis",
      jobTitle1: "Développeur Web full stack",
      jobTitle2: "Data Scientist",
      subtitle: "Développeur Full Stack & Data Scientist",
      cta_contact: "Me contacter",
      cta_cv: "Télécharger CV",
      scroll_hint: "Découvrir mon univers"
    },

    // ================================
    // SECTIONS PRINCIPALES (TITRES UI UNIQUEMENT)
    // ================================
    about: {
      title: "À propos de moi",
      subtitle: "Mon parcours et ma passion",
      download_cv: "Télécharger mon CV",
      personal_info: "Informations personnelles",
      quote_section: "Citation personnelle"
    },

    skills: {
      title: "Mes Compétences",
      subtitle: "Technologies et outils maîtrisés",
      frontend: "Front-End",
      backend: "Back-End",
      dataScience: "Data Science",
      tools: "Outils & Méthodes",
      level: "Niveau",
      beginner: "Débutant",
      intermediate: "Intermédiaire",
      advanced: "Avancé",
      expert: "Expert",
      years_experience: "années d'expérience",
      loading: "Chargement des compétences...",
      favorites: {
        title: "Compétences Principales"
      }
    },

    projects: {
      title: "Mes Projets",
      subtitle: "Découvrez mes réalisations",
      academic: "Projets Académiques",
      professional: "Projets Professionnels",
      personal: "Projets Personnels",
      view_project: "Voir le projet",
      view_code: "Voir le code",
      view_site: "Voir le site",
      viewSite: "Voir le site",
      viewCode: "Voir le code",
      viewFrontend: "Frontend",
      viewBackend: "Backend",
      viewDetails: "Voir les détails",
      view_live: "Voir en ligne",
      view_github: "Code source",
      technologies: "Technologies utilisées",
      technologiesUsed: "Technologies utilisées",
      features: "Fonctionnalités du projet",
      description: "Description",
      noProjects: "Aucun projet disponible",
      no_projects: "Aucun projet disponible",
      allProjects: "Tous les projets",
      showAll: "Afficher tout",
      showAcademic: "Voir mes projets d'examen DWWM",
      hideAcademic: "Masquer les projets d'examen",
      academicProjects: "Projets d'examen DWWM",
      examProject: "Projet d'examen",
      professionalProjects: "Projets professionnels",
      filterBy: "Filtrer par technologie",
      filter_all: "Tous",
      clickForDetails: "Cliquez pour voir les détails",
      loading: "Chargement des projets...",
      error_loading: "Erreur lors du chargement des projets",
      retry_loading: "Réessayer",
      modal_close: "Fermer la modale",
      imageModal: {
        close: "Fermer",
        next: "Suivant",
        previous: "Précédent",
        view: "Voir les images",
        openGallery: "Ouvrir la galerie pour {{project}}",
        description: "Galerie d'images pour {{project}}, image {{current}} sur {{total}}"
      }
    },

    education: {
      title: "Formation",
      subtitle: "Mon parcours académique et professionnel",
      year: "Année",
      years: "années",
      institution: "Établissement",
      certification: "Certification",
      diploma: "Diplôme",
      rncp_code: "Code RNCP",
      viewCertification: "Voir la certification",
      level: "Niveau",
      duration: "Durée",
      present: "Présent",
      ongoing: "En cours",
      completed: "Terminé",
      skills_acquired: "Compétences acquises",
      project: "Projet de validation",
      loading: "Chargement de la formation..."
    },

    experience: {
      title: "Expérience",
      subtitle: "Mon parcours professionnel",
      role: "Poste",
      company: "Entreprise",
      duration: "Durée",
      period: "Période",
      present: "Présent",
      ongoing: "En cours",
      skills: "Compétences",
      technologies: "Technologies utilisées",
      achievements: "Réalisations",
      responsibilities: "Responsabilités",
      team_size: "Taille de l'équipe",
      context: "Contexte",
      loading: "Chargement de l'expérience..."
    },

    hobbies: {
      title: "Mes passions & centres d'intérêt",
      subtitle: "Ce qui me passionne en dehors du travail",
      category: "Catégorie",
      hobby: "Passion",
      description: "Description",
      why_passionate: "Pourquoi cette passion",
      related_skills: "Compétences liées"
    },

    expertise: {
      title: "Mon savoir-faire",
      subtitle: "Mes domaines d'expertise",
      description: "J'accompagne mes clients de l'analyse des besoins à la mise en ligne, en priorisant qualité, accessibilité et performance.",
      approach: "Approche centrée utilisateur, communication fluide, code maintenable et documenté.",
      methodology: "Méthodologie",
      categories: {
        ux: "UX/UI",
        technical: "Technique",
        quality: "Qualité",
        security: "Sécurité",
        data: "Data",
        devops: "DevOps",
        management: "Gestion de projet"
      }
    },

    // ================================
    // CONTACT ET form
    // ================================
    contact: {
      title: "Contactez-moi",
      subtitle: "Discutons de vos projets",
      intro: "N'hésitez pas à me contacter pour discuter de vos projets",
      form_title: "Formulaire de contact",
      form_name: "Nom complet",
      form_email: "Adresse email",
      form_subject: "Sujet",
      form_message: "Message",
      form_send: "Envoyer le message",
      form_sending: "Envoi en cours...",
      form_reset: "Réinitialiser",
      name: "Nom",
      email: "Email",
      subject: "Sujet",
      message: "Votre message",
      send: "Envoyer",
      sending: "Envoi en cours...",
      success: "Message envoyé avec succès !",
      error: "Une erreur est survenue. Veuillez réessayer.",
      or: "Ou écrivez-moi directement à :",
      direct: "jf.c.webcraft@gmail.com",
      phone: "Téléphone",
      address: "Adresse",
      social_networks: "Réseaux sociaux",
      formAriaLabel: "Formulaire de contact",
      directAriaLabel: "Envoyer un email directement",
      required_field: "Ce champ est requis",
      optional_field: "Optionnel",
      char_count: "caractères",
      char_remaining: "caractères restants",
      invalid_email: "Veuillez saisir une adresse email valide.",
      invalidEmail: "Veuillez saisir une adresse email valide.",
      invalid_name: "Veuillez saisir un nom valide (2 caractères minimum).",
      invalidName: "Veuillez saisir un nom valide (2 caractères minimum).",
      invalid_message: "Veuillez saisir un message d'au moins 10 caractères.",
      invalidMessage: "Veuillez saisir un message d'au moins 10 caractères.",
      invalid_captcha: "Veuillez confirmer que vous n'êtes pas un robot",
      invalidCaptcha: "Veuillez confirmer que vous n'êtes pas un robot",
      too_many_attempts: "Trop de tentatives. Veuillez réessayer dans une minute",
      tooManyAttempts: "Trop de tentatives. Veuillez réessayer dans une minute",
      blocked: "Patientez...",
      too_many_requests_global: "Trop de requêtes. Veuillez réessayer plus tard.",
      tooManyRequestsGlobal: "Trop de requêtes. Veuillez réessayer plus tard.",
      errorValidation: "Veuillez vérifier les champs du formulaire.",
      errorConfig: "Erreur de configuration du service de messagerie.",
      errorForm: "Erreur avec le formulaire.",
      errorSending: "Erreur lors de l'envoi du message. Veuillez réessayer plus tard.",
      requiredFields: "Champs obligatoires",
      alternative: "Ou écrivez-moi directement à :",
      captchaLabel: "Vérification Captcha",
      privacy_notice: "Vos données personnelles sont protégées et ne seront utilisées que pour vous répondre."
    },

    // ================================
    // FOOTER ET LIENS
    // ================================
    footer: {
      copyright: "© 2024 Portfolio Webcraft. Tous droits réservés.",
      builtWith: "Créé avec React et Vanilla Extract CSS",
      connect: "Retrouvez-moi",
      social_networks: "Réseaux sociaux",
      useful_links: "Liens utiles",
      legal_mentions: "Mentions légales",
      privacy_policy: "Politique de confidentialité",
      sitemap: "Plan du site",
      back_to_top: "Retour en haut de la page",
      backToTop: "Retour en haut de la page",
      last_update: "Dernière mise à jour"
    },

    // ================================
    // interface user (UI)
    // ================================
    ui: {
      loading: "Chargement...",
      error: "Une erreur est survenue",
      success: "Succès",
      warning: "Attention",
      info: "Information",
      retry: "Réessayer",
      close: "Fermer",
      open: "Ouvrir",
      show: "Afficher",
      hide: "Masquer",
      save: "Sauvegarder",
      cancel: "Annuler",
      confirm: "Confirmer",
      delete: "Supprimer",
      edit: "Modifier",
      create: "Créer",
      update: "Mettre à jour",
      add: "Ajouter",
      remove: "Retirer",
      search: "Rechercher",
      filter: "Filtrer",
      sort: "Trier",
      reset: "Réinitialiser",
      clear: "Effacer",
      select: "Sélectionner",
      previous: "Précédent",
      next: "Suivant",
      first: "Premier",
      last: "Dernier",
      page: "Page",
      of: "sur",
      results: "résultats",
      result: "résultat",
      no_results: "Aucun résultat trouvé",
      select_all: "Tout sélectionner",
      clear_all: "Tout effacer",
      expand: "Développer",
      collapse: "Réduire",
      toggle: "Basculer",
      view_more: "Voir plus",
      view_less: "Voir moins",
      copy: "Copier",
      copied: "Copié !",
      download: "Télécharger",
      upload: "Téléverser",
      print: "Imprimer",
      share: "Partager",
      favorite: "Favori",
      bookmark: "Marque-page"
    },

    // ================================
    // ACCESSIBILITÉ
    // ================================
    accessibility: {
      skip_to_content: "Aller au contenu principal",
      skipToContent: "Aller au contenu principal",
      skip_to_navigation: "Aller à la navigation",
      skip_to_footer: "Aller au pied de page",
      toggle_menu: "Ouvrir/fermer le menu",
      toggleMenu: "Ouvrir/fermer le menu",
      mobile_menu: "Menu mobile",
      mobileMenu: "Menu mobile",
      navigation: "Navigation",
      main_navigation: "Navigation principale",
      mainNavigation: "Navigation principale",
      secondary_navigation: "Navigation secondaire",
      breadcrumb: "Fil d'Ariane",
      close_menu: "Fermer le menu",
      closeMenu: "Fermer le menu",
      open_menu: "Ouvrir le menu",
      current_page: "Page actuelle",
      external_link: "Lien externe",
      new_window: "Ouvre dans une nouvelle fenêtre",
      animationInProgress: "Animation de la citation en cours...",
      animationComplete: "Animation de la citation terminée.",
      animationSkipped: "Animation de la citation passée.",
      skip: "Passer",
      skipAnimation: "Passer l'animation de la citation",
      hobbiesNavigation: "Utilisez les flèches droite et gauche pour naviguer entre les centres d'intérêt, Entrée pour activer/désactiver le détail, et Échap pour fermer.",
      image_alt: "Image de",
      video_description: "Vidéo de présentation",
      audio_description: "Description audio disponible",
      keyboard_shortcut: "Raccourci clavier",
      screen_reader_only: "Contenu réservé aux lecteurs d'écran",
      loading_content: "Chargement du contenu en cours",
      error_content: "Erreur lors du chargement du contenu"
    },

    // ================================
    // administration (interface)
    // ================================
    admin: {
      title: "Administration",
      dashboard: "Tableau de bord",
      login: "Connexion",
      logout: "Déconnexion",
      email: "Email",
      password: "Mot de passe",
      login_button: "Se connecter",
      logout_button: "Se déconnecter",
      unauthorized: "Accès non autorisé",
      session_expired: "Session expirée",
      welcome: "Bienvenue dans l'interface d'administration",
      
      // navigation admin
      nav: {
        overview: "Vue d'ensemble",
        content: "Contenu",
        settings: "Paramètres",
        users: "Utilisateurs",
        analytics: "Statistiques"
      },

      // Statistiques
      stats: {
        title: "Statistiques",
        projects: "Projets",
        sections: "Sections",
        skills: "Compétences",
        quotes: "Citations",
        visitors: "Visiteurs",
        messages: "Messages",
        total: "Total",
        visible: "Visibles",
        hidden: "Masqués",
        published: "Publiés",
        draft: "Brouillons",
        academic: "Académiques",
        professional: "Professionnels",
        this_month: "Ce mois",
        this_week: "Cette semaine",
        today: "Aujourd'hui"
      },

      // handling des projets
      projects: {
        title: "Gestion des Projets",
        list: "Liste des projets",
        create: "Créer un projet",
        edit: "Modifier le projet",
        delete: "Supprimer le projet",
        duplicate: "Dupliquer le projet",
        title_field: "Titre",
        description_field: "Description",
        technologies_field: "Technologies",
        category_field: "Catégorie",
        status_field: "Statut",
        visibility_field: "Visibilité",
        type_academic: "Projet académique",
        type_professional: "Projet professionnel",
        type_personal: "Projet personnel",
        live_url: "URL du projet",
        github_url: "URL GitHub",
        image_url: "Image du projet",
        featured: "Projet mis en avant",
        published: "Publié",
        draft: "Brouillon",
        archived: "Archivé",
        save_success: "Projet sauvegardé avec succès",
        delete_success: "Projet supprimé avec succès",
        delete_confirm: "Êtes-vous sûr de vouloir supprimer ce projet ?",
        add: "Nouveau projet",
        images: "Gérer les images",
        gallery: "Galerie d'images",
        order: "Ordre d'affichage",
        tags: "Étiquettes",
        seo: "Référencement"
      },

      // handling des compétences
      skills: {
        title: "Gestion des compétences",
        list: "Liste des compétences",
        add: "Nouvelle compétence",
        edit: "Modifier la compétence",
        delete: "Supprimer la compétence",
        categories: "Catégories",
        level: "Niveau de maîtrise",
        experience: "Années d'expérience",
        icon: "Icône",
        color: "Couleur",
        description: "Description",
        featured: "Compétence principale",
        order: "Ordre d'affichage"
      },

      // Upload et médias
      upload: {
        title: "Gestion des médias",
        dragDrop: "Glissez vos images ici ou cliquez pour sélectionner",
        browse: "Parcourir les fichiers",
        formats: "Formats acceptés: JPG, PNG, WebP, GIF",
        maxSize: "Taille maximum: 10MB",
        uploading: "Upload en cours...",
        progress: "Progression",
        success: "Upload réussi",
        error: "Erreur lors de l'upload",
        delete_image: "Supprimer l'image",
        image_alt: "Texte alternatif",
        image_title: "Titre de l'image",
        optimize: "Optimiser l'image",
        resize: "Redimensionner",
        crop: "Recadrer",
        gallery: "Galerie",
        library: "Bibliothèque multimédia"
      },

      // Formulaires
      form: {
        save: "Sauvegarder",
        save_draft: "Sauvegarder comme brouillon",
        publish: "Publier",
        cancel: "Annuler",
        reset: "Réinitialiser",
        preview: "Aperçu",
        required: "Obligatoire",
        optional: "Optionnel",
        help_text: "Texte d'aide",
        char_count: "Nombre de caractères",
        word_count: "Nombre de mots",
        auto_save: "Sauvegarde automatique",
        unsaved_changes: "Modifications non sauvegardées",
        validation_error: "Erreur de validation",
        field_required: "Ce champ est obligatoire",
        field_invalid: "Ce champ contient des données invalides"
      },

      // Actions générales
      actions: {
        create: "Créer",
        read: "Lire",
        update: "Mettre à jour",
        delete: "Supprimer",
        duplicate: "Dupliquer",
        archive: "Archiver",
        restore: "Restaurer",
        export: "Exporter",
        import: "Importer",
        backup: "Sauvegarder",
        sync: "Synchroniser",
        refresh: "Actualiser",
        search: "Rechercher",
        filter: "Filtrer",
        sort: "Trier",
        bulk_actions: "Actions en lot",
        select_all: "Tout sélectionner",
        deselect_all: "Tout désélectionner"
      }
    },

    // ================================
    // COMMON / GÉNÉRAL
    // ================================
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      warning: "Attention",
      info: "Information",
      retry: "Réessayer",
      close: "Fermer",
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      add: "Ajouter",
      create: "Créer",
      update: "Mettre à jour",
      view: "Voir",
      search: "Rechercher",
      filter: "Filtrer",
      sort: "Trier",
      confirm: "Confirmer",
      yes: "Oui",
      no: "Non",
      maybe: "Peut-être",
      ok: "OK",
      done: "Terminé",
      continue: "Continuer",
      back: "Retour",
      forward: "Suivant",
      home: "Accueil",
      settings: "Paramètres",
      help: "Aide",
      about: "À propos",
      contact: "Contact",
      more: "Plus",
      less: "Moins",
      all: "Tout",
      none: "Aucun",
      other: "Autre",
      unknown: "Inconnu",
      not_available: "Non disponible",
      coming_soon: "Bientôt disponible"
    },

    // ================================
    // navigation GÉNÉRALE
    // ================================
    navigation: {
      home: "Accueil",
      about: "À propos",
      projects: "Projets",
      skills: "Compétences",
      education: "Formation",
      experience: "Expérience",
      hobbies: "Passions",
      contact: "Contact",
      admin: "Administration",
      blog: "Blog",
      portfolio: "Portfolio",
      services: "Services",
      testimonials: "Témoignages",
      faq: "FAQ",
      legal: "Mentions légales",
      privacy: "Confidentialité",
      sitemap: "Plan du site"
    },

    // ================================
    // MESSAGES ET NOTIFICATIONS
    // ================================
    messages: {
      success: "Opération réussie",
      error: "Une erreur est survenue",
      warning: "Attention",
      info: "Information",
      confirm_delete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
      confirm_action: "Êtes-vous sûr de vouloir effectuer cette action ?",
      unsaved_changes: "Vous avez des modifications non sauvegardées",
      save_before_leave: "Voulez-vous sauvegarder avant de quitter ?",
      network_error: "Erreur de connexion réseau",
      server_error: "Erreur serveur",
      timeout_error: "Délai d'attente dépassé",
      unauthorized_access: "Accès non autorisé",
      forbidden_access: "Accès interdit",
      not_found: "Élément introuvable",
      session_expired: "Votre session a expiré",
      validation_error: "Erreur de validation des données",
      file_too_large: "Le fichier est trop volumineux",
      invalid_file_type: "Type de fichier non supporté",
      upload_failed: "Échec du téléversement",
      operation_cancelled: "Opération annulée",
      no_internet: "Aucune connexion Internet",
      maintenance_mode: "Site en maintenance",
      try_again_later: "Veuillez réessayer plus tard"
    },

    // ================================
    // FORMATS ET UNITÉS
    // ================================
    formats: {
      date: {
        short: "dd/mm/yyyy",
        long: "dd mmmm yyyy",
        relative_now: "À l'instant",
        relative_minutes: "Il y a {{count}} minutes",
        relative_hours: "Il y a {{count}} heures",
        relative_days: "Il y a {{count}} jours",
        relative_weeks: "Il y a {{count}} semaines",
        relative_months: "Il y a {{count}} mois",
        relative_years: "Il y a {{count}} années"
      },
      file_size: {
        bytes: "octets",
        kb: "Ko",
        mb: "Mo",
        gb: "Go",
        tb: "To"
      },
      numbers: {
        thousand: "k",
        million: "M",
        billion: "B"
      }
    },

    // ================================
    // SEO ET MÉTADONNÉES
    // ================================
    seo: {
      title: "Portfolio – Jean-François Chaussoy | Développeur Web & Data Science",
      description: "Portfolio de Jean-François Chaussoy, développeur web spécialisé en React et Data Science.",
      keywords: "développeur web,data science,React,full stack,portfolio,TypeScript,Node.js",
      jobTitle: "Développeur Web Full Stack & Data Scientist",
      occupation: "Développeur Web",
      og_title: "Portfolio Webcraft - Développeur Full Stack",
      og_description: "Portfolio professionnel d'un développeur full stack et data scientist",
      og_type: "website",
      og_locale: "fr_FR",
      twitter_title: "Portfolio Webcraft",
      twitter_description: "Découvrez mes projets et compétences en développement web et data science",
      twitter_card: "summary_large_image",
      canonical_url: "HTTPS://portfolio-webcraft.com",
      robots: "index, follow",
      language: "fr",
      author: "Jean-François Chaussoy",
      copyright: "© 2024 Portfolio Webcraft"
    },

    // ================================
    // POLITIQUE DE CONFIDENTIALITÉ
    // ================================
    privacyPolicy: {
      title: "🔐 Votre vie privée, ma priorité",
      subtitle: "Comment je protège vos données avec soin",
      lastUpdated: "Dernière mise à jour",
      required: "Obligatoire",
      optional: "Optionnel",
      toc: {
        title: "Table des matières 📋"
      },
      sections: {
        introduction: {
          title: "👋 Salut !",
          content1: "Bonjour, je suis Jean-François, et je veux vous expliquer simplement comment je prends soin de vos données quand vous visitez mon portfolio.",
          content2: "La transparence, c'est ma devise : vous saurez exactement ce qui se passe avec vos informations.",
          highlight: "Votre confiance est précieuse ! Je ne collecte que les données vraiment utiles pour vous offrir la meilleure expérience possible. 🤝"
        },
        dataCollection: {
          title: "📱 Les données que je collecte",
          intro: "Je récupère des informations de deux façons :",
          automatic: {
            title: "Ce qui est automatique (comme des empreintes)",
            ip: "Votre adresse IP et localisation approximative",
            browser: "Le type de navigateur que vous utilisez",
            device: "Votre type d'appareil",
            pages: "Les pages que vous visitez et le temps passé",
            duration: "Votre durée de visite et interactions"
          },
          voluntary: {
            title: "Ce que vous partagez directement avec moi",
            name: "Votre nom (quand vous me contactez)",
            email: "Votre email (pour vous répondre)",
            message: "Vos messages (quand vous m'écrivez)",
            preferences: "Vos préférences (thème, cookies, etc.)"
          }
        },
        dataUsage: {
          title: "🎯 À quoi servent ces données ?",
          intro: "Voici comment j'utilise ces informations pour vous servir :",
          functionality: {
            title: "Pour que tout fonctionne bien",
            desc: "Garder vos préférences (thème sombre/clair, langue) pour votre confort"
          },
          communication: {
            title: "Pour discuter avec vous",
            desc: "Répondre à vos messages et rester en contact"
          },
          analytics: {
            title: "Pour m'améliorer",
            desc: "Comprendre comment vous utilisez le site et le rendre encore meilleur"
          },
          security: {
            title: "Pour votre sécurité",
            desc: "Protéger le site contre les mauvaises intentions et garder vos données en sécurité"
          }
        },
        cookies: {
          title: "🍪 Les cookies",
          intro: "J'utilise différents types de cookies :",
          necessary: {
            title: "Cookies essentiels",
            desc: "Nécessaires au fonctionnement de base du site",
            consent: "Stocke vos préférences de cookies",
            theme: "Se souvient de votre préférence de thème (sombre/clair)",
            language: "Se souvient de votre préférence de langue"
          },
          analytics: {
            title: "Cookies d'analyse",
            desc: "M'aident à comprendre l'utilisation du site avec Google Analytics"
          },
          marketing: {
            title: "Cookies marketing",
            desc: "Actuellement non utilisés sur ce site"
          }
        },
        dataSharing: {
          title: "🤝 Partage des données",
          noSharing: "Je ne vends, ne loue, ni ne partage vos données personnelles avec des tiers à des fins commerciales.",
          content1: "Vos données ne sont partagées qu'avec des prestataires de confiance qui m'aident à faire fonctionner le site web :",
          thirdParty: {
            title: "Services tiers",
            analytics: "Statistiques d'utilisation anonymes pour améliorer le site",
            hosting: "Hébergement sécurisé et diffusion de contenu (Hostinger VPS)",
            emailjs: "Service d'envoi d'emails via EmailJS pour le formulaire de contact",
            recaptcha: "Protection anti-spam via Google reCAPTCHA"
          }
        },
        dataSecurity: {
          title: "🛡️ Comment je protège vos données",
          intro: "Je ne plaisante pas avec la sécurité ! Voici mes mesures :",
          https: "Chiffrement HTTPS pour des échanges ultra-sécurisés",
          headers: "Protection contre les attaques malveillantes",
          rateLimit: "Limitation des requêtes pour prévenir les abus",
          validation: "Vérification rigoureuse de toutes les saisies",
          monitoring: "Surveillance sécuritaire continue"
        },
        userRights: {
          title: "✨ Vos super-pouvoirs",
          intro: "Le RGPD vous donne des droits, utilisez-les !",
          access: {
            title: "Droit d'accès",
            desc: "Vous pouvez voir toutes les données que j'ai sur vous"
          },
          rectification: {
            title: "Droit de rectification",
            desc: "Une erreur ? Dites-le moi, je corrige !"
          },
          erasure: {
            title: "Droit à l'oubli",
            desc: "Envie de tout supprimer ? Pas de souci !"
          },
          portability: {
            title: "Droit à la portabilité",
            desc: "Vos données vous appartiennent, emmenez-les où vous voulez"
          }
        },
        contact: {
          title: "📬 Parlons-nous !",
          intro: "Des questions sur vos données ou vos droits ? Je suis là !",
          email: "Mon email",
          response: "Délai de réponse",
          responseTime: "Je réponds sous 30 jours maximum (souvent bien plus vite 😉)",
          authority: {
            title: "Autorité de contrôle",
            desc: "Vous pouvez aussi contacter la CNIL si besoin :",
            link: "Contacter la CNIL (la police des données en France)"
          }
        }
      }
    },

    // ================================
    // MENTIONS LÉGALES
    // ================================
    legal: {
      title: "Mentions légales",
      subtitle: "Informations légales sur ce site web",
      sections: {
        editor: {
          title: "Éditeur du site",
          name: "Nom",
          status: "Statut",
          statusValue: "Particulier / Développeur indépendant",
          address: "Adresse",
          addressNote: "Adresse exacte disponible sur demande",
          contact: "Contact",
          website: "Site web"
        },
        hosting: {
          title: "Hébergement"
        },
        property: {
          title: "Propriété intellectuelle",
          content1: "Tous les contenus présents sur ce site (textes, images, code, design) sont la propriété de Jean-François Chaussoy sauf mention contraire.",
          content2: "Toute reproduction, même partielle, est interdite sans autorisation écrite préalable.",
          exceptions: {
            title: "Exceptions",
            icons: "Icônes : React Icons (Licence MIT)",
            fonts: "Polices : Google Fonts (SIL Open Font License)",
            libraries: "Bibliothèques JavaScript : Diverses licences open source",
            images: "Certaines images : Unsplash (Licence Unsplash)"
          }
        },
        responsibility: {
          title: "Responsabilité",
          limitations: {
            title: "Limitation de responsabilité",
            content1: "Les informations de ce site sont fournies 'en l'état' sans garantie d'aucune sorte.",
            content2: "Nous ne pouvons être tenus responsables des dommages directs ou indirects résultant de l'utilisation de ce site."
          },
          accuracy: {
            title: "Exactitude des informations",
            content: "Nous nous efforçons de maintenir des informations exactes et à jour, mais nous ne pouvons garantir leur exhaustivité ou exactitude."
          },
          links: {
            title: "Liens externes",
            content: "Ce site peut contenir des liens vers des sites externes. Nous ne sommes pas responsables du contenu ou des pratiques de confidentialité de ces sites."
          }
        },
        data: {
          title: "Données personnelles",
          intro: "Ce site peut collecter les données personnelles suivantes :",
          technical: {
            title: "Données techniques",
            logs: "Journaux de connexion (IP, navigateur, pages visitées)",
            analytics: "Statistiques d'utilisation anonymisées",
            preferences: "Préférences utilisateur (thème, langue)"
          },
          contact: {
            title: "Données de contact",
            name: "Nom (si fourni)",
            email: "Adresse email (si fournie)",
            message: "Contenu des messages (si fourni)"
          },
          gdpr: "Pour plus d'informations sur le traitement des données, consultez notre",
          privacyPolicy: "Politique de confidentialité"
        },
        thirdParty: {
          title: "Services tiers utilisés",
          intro: "Ce site utilise les services tiers suivants :",
          emailjs: {
            name: "EmailJS",
            purpose: "Service d'envoi d'emails pour le formulaire de contact",
            website: "HTTPS://www.emailjs.com"
          },
          recaptcha: {
            name: "Google reCAPTCHA",
            purpose: "Protection contre les robots et spam",
            website: "HTTPS://www.google.com/recaptcha"
          }
        },
        applicable: {
          title: "Droit applicable",
          content1: "Ce site est régi par le droit français.",
          content2: "Tout litige sera soumis à la compétence des tribunaux français.",
          jurisdiction: {
            title: "Juridiction",
            content: "En cas de litige, les tribunaux du domicile de l'éditeur auront compétence exclusive."
          }
        },
        contact: {
          title: "Contact",
          intro: "Pour toute question concernant ces mentions légales :",
          email: {
            title: "Email",
            response: "Réponse sous 48h"
          },
          form: {
            title: "Formulaire de contact",
            link: "Utiliser le formulaire de contact",
            response: "Réponse sous 24h"
          }
        }
      },
      footer: {
        lastUpdate: "Dernière mise à jour",
        privacy: "Politique de confidentialité",
        cookies: "Politique des cookies"
      }
    }
  },

  // ================================
  // TRADUCTIONS ANGLAISES
  // ================================
  en: {
    // ================================
    // navigation AND MENU
    // ================================
    menu: {
      home: "Home",
      about: "About",
      skills: "Skills",
      projects: "Projects",
      education: "Education",
      experience: "Experience",
      contact: "Contact",
      services: "Services",
      cv: "Resume",
      downloadCV: "Download Resume"
    },

    // ================================
    // HEADER AND HERO section
    // ================================
    header: {
      greeting: "Hello, I'm",
      jobTitle1: "Full Stack Web Developer",
      jobTitle2: "Data Scientist",
      subtitle: "Full Stack Developer & Data Scientist",
      cta_contact: "Contact me",
      cta_cv: "Download CV",
      scroll_hint: "Discover my universe"
    },

    // ================================
    // MAIN SECTIONS (UI TITLES ONLY)
    // ================================
    about: {
      title: "About me",
      subtitle: "My journey and passion",
      download_cv: "Download my CV",
      personal_info: "Personal information",
      quote_section: "Personal quote"
    },

    skills: {
      title: "My Skills",
      subtitle: "Technologies and tools mastered",
      frontend: "Front-End",
      backend: "Back-End",
      dataScience: "Data Science",
      tools: "Tools & Methods",
      level: "Level",
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
      expert: "Expert",
      years_experience: "years of experience",
      loading: "Loading skills...",
      favorites: {
        title: "Main Skills"
      }
    },

    projects: {
      title: "My Projects",
      subtitle: "Discover my achievements",
      academic: "Academic Projects",
      professional: "Professional Projects",
      personal: "Personal Projects",
      view_project: "View project",
      view_code: "View code",
      view_site: "View site",
      viewSite: "View site",
      viewCode: "View code",
      viewFrontend: "Frontend",
      viewBackend: "Backend",
      viewDetails: "View details",
      view_live: "View live",
      view_github: "Source code",
      technologies: "Technologies used",
      technologiesUsed: "Technologies used",
      features: "Project features",
      description: "Description",
      noProjects: "No projects available",
      no_projects: "No projects available",
      allProjects: "All projects",
      showAll: "Show all",
      showAcademic: "Show my exam projects",
      hideAcademic: "Hide exam projects",
      academicProjects: "Exam Projects",
      examProject: "Exam project",
      professionalProjects: "Professional projects",
      filterBy: "Filter by technology",
      filter_all: "All",
      clickForDetails: "Click to see details",
      loading: "Loading projects...",
      error_loading: "Error loading projects",
      retry_loading: "Retry",
      modal_close: "Close modal",
      imageModal: {
        close: "Close",
        next: "Next",
        previous: "Previous",
        view: "View images",
        openGallery: "Open gallery for {{project}}",
        description: "Image gallery for {{project}}, image {{current}} of {{total}}"
      }
    },

    education: {
      title: "Education",
      subtitle: "My academic and professional background",
      year: "Year",
      years: "years",
      institution: "Institution",
      certification: "Certification",
      diploma: "Diploma",
      rncp_code: "RNCP Code",
      viewCertification: "View certification",
      level: "Level",
      duration: "Duration",
      present: "Present",
      ongoing: "Ongoing",
      completed: "Completed",
      skills_acquired: "Skills acquired",
      project: "Validation project",
      loading: "Loading education..."
    },

    experience: {
      title: "Experience",
      subtitle: "My professional journey",
      role: "Role",
      company: "Company",
      duration: "Duration",
      period: "Period",
      present: "Present",
      ongoing: "Ongoing",
      skills: "Skills",
      technologies: "Technologies used",
      achievements: "Achievements",
      responsibilities: "Responsibilities",
      team_size: "Team size",
      context: "Context",
      loading: "Loading experience..."
    },

    hobbies: {
      title: "My passions & interests",
      subtitle: "What I'm passionate about outside of work",
      category: "Category",
      hobby: "Passion",
      description: "Description",
      why_passionate: "Why this passion",
      related_skills: "Related skills"
    },

    expertise: {
      title: "My expertise",
      subtitle: "My areas of expertise",
      description: "I support my clients from needs analysis to deployment, prioritizing quality, accessibility, and performance.",
      approach: "User-centered approach, fluid communication, maintainable and documented code.",
      methodology: "Methodology",
      categories: {
        ux: "UX/UI",
        technical: "Technical",
        quality: "Quality",
        security: "Security",
        data: "Data",
        devops: "DevOps",
        management: "Project management"
      }
    },

    // ================================
    // CONTACT AND FORM
    // ================================
    contact: {
      title: "Contact me",
      subtitle: "Let's discuss your projects",
      intro: "Don't hesitate to contact me to discuss your projects",
      form_title: "Contact form",
      form_name: "Full name",
      form_email: "Email address",
      form_subject: "Subject",
      form_message: "Message",
      form_send: "Send message",
      form_sending: "Sending...",
      form_reset: "Reset",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Your message",
      send: "Send",
      sending: "Sending...",
      success: "Message sent successfully!",
      error: "An error occurred. Please try again.",
      or: "Or email me directly at:",
      direct: "jf.c.webcraft@gmail.com",
      phone: "Phone",
      address: "Address",
      social_networks: "Social networks",
      formAriaLabel: "Contact form",
      directAriaLabel: "Send email directly",
      required_field: "This field is required",
      optional_field: "Optional",
      char_count: "characters",
      char_remaining: "characters remaining",
      invalid_email: "Please enter a valid email address.",
      invalidEmail: "Please enter a valid email address.",
      invalid_name: "Please enter a valid name (minimum 2 characters).",
      invalidName: "Please enter a valid name (minimum 2 characters).",
      invalid_message: "Please enter a message of at least 10 characters.",
      invalidMessage: "Please enter a message of at least 10 characters.",
      invalid_captcha: "Please confirm you are not a robot",
      invalidCaptcha: "Please confirm you are not a robot",
      too_many_attempts: "Too many attempts. Please try again in a minute",
      tooManyAttempts: "Too many attempts. Please try again in a minute",
      blocked: "Please wait...",
      too_many_requests_global: "Too many requests. Please try again later.",
      tooManyRequestsGlobal: "Too many requests. Please try again later.",
      errorValidation: "Please check the form fields.",
      errorConfig: "Email service configuration error.",
      errorForm: "Error with the form.",
      errorSending: "Error sending the message. Please try again later.",
      requiredFields: "Required fields",
      alternative: "Or email me directly at:",
      captchaLabel: "Captcha Verification",
      privacy_notice: "Your personal data is protected and will only be used to respond to you."
    },

    // ================================
    // FOOTER AND LINKS
    // ================================
    footer: {
      copyright: "© 2024 Portfolio Webcraft. All rights reserved.",
      builtWith: "Built with React and Vanilla Extract CSS",
      connect: "Connect with me",
      social_networks: "Social networks",
      useful_links: "Useful links",
      legal_mentions: "Legal notices",
      privacy_policy: "Privacy policy",
      sitemap: "Sitemap",
      back_to_top: "Back to top",
      backToTop: "Back to top",
      last_update: "Last update"
    },

    // ================================
    // USER interface (UI)
    // ================================
    ui: {
      loading: "Loading...",
      error: "An error occurred",
      success: "Success",
      warning: "Warning",
      info: "Information",
      retry: "Retry",
      close: "Close",
      open: "Open",
      show: "Show",
      hide: "Hide",
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      update: "Update",
      add: "Add",
      remove: "Remove",
      search: "Search",
      filter: "Filter",
      sort: "Sort",
      reset: "Reset",
      clear: "Clear",
      select: "Select",
      previous: "Previous",
      next: "Next",
      first: "First",
      last: "Last",
      page: "Page",
      of: "of",
      results: "results",
      result: "result",
      no_results: "No results found",
      select_all: "Select all",
      clear_all: "Clear all",
      expand: "Expand",
      collapse: "Collapse",
      toggle: "Toggle",
      view_more: "View more",
      view_less: "View less",
      copy: "Copy",
      copied: "Copied!",
      download: "Download",
      upload: "Upload",
      print: "Print",
      share: "Share",
      favorite: "Favorite",
      bookmark: "Bookmark"
    },

    // ================================
    // ACCESSIBILITY
    // ================================
    accessibility: {
      skip_to_content: "Skip to main content",
      skipToContent: "Skip to main content",
      skip_to_navigation: "Skip to navigation",
      skip_to_footer: "Skip to footer",
      toggle_menu: "Toggle menu",
      toggleMenu: "Toggle menu",
      mobile_menu: "Mobile menu",
      mobileMenu: "Mobile menu",
      navigation: "Navigation",
      main_navigation: "Main navigation",
      mainNavigation: "Main navigation",
      secondary_navigation: "Secondary navigation",
      breadcrumb: "Breadcrumb",
      close_menu: "Close menu",
      closeMenu: "Close menu",
      open_menu: "Open menu",
      current_page: "Current page",
      external_link: "External link",
      new_window: "Opens in new window",
      animationInProgress: "Quote animation in progress...",
      animationComplete: "Quote animation completed.",
      animationSkipped: "Quote animation skipped.",
      skip: "Skip",
      skipAnimation: "Skip quote animation",
      hobbiesNavigation: "Use left and right arrows to navigate between hobbies, Enter to toggle details, and Escape to close.",
      image_alt: "Image of",
      video_description: "Presentation video",
      audio_description: "Audio description available",
      keyboard_shortcut: "Keyboard shortcut",
      screen_reader_only: "Screen reader only content",
      loading_content: "Loading content",
      error_content: "Error loading content"
    },

    // ================================
    // administration (interface)
    // ================================
    admin: {
      title: "Administration",
      dashboard: "Dashboard",
      login: "Login",
      logout: "Logout",
      email: "Email",
      password: "Password",
      login_button: "Sign in",
      logout_button: "Sign out",
      unauthorized: "Unauthorized access",
      session_expired: "Session expired",
      welcome: "Welcome to the administration interface",
      
      // Admin navigation
      nav: {
        overview: "Overview",
        content: "Content",
        settings: "Settings",
        users: "Users",
        analytics: "Analytics"
      },

      // Statistics
      stats: {
        title: "Statistics",
        projects: "Projects",
        sections: "Sections",
        skills: "Skills",
        quotes: "Quotes",
        visitors: "Visitors",
        messages: "Messages",
        total: "Total",
        visible: "Visible",
        hidden: "Hidden",
        published: "Published",
        draft: "Drafts",
        academic: "Academic",
        professional: "Professional",
        this_month: "This month",
        this_week: "This week",
        today: "Today"
      },

      // Project management
      projects: {
        title: "Project Management",
        list: "Project list",
        create: "Create project",
        edit: "Edit project",
        delete: "Delete project",
        duplicate: "Duplicate project",
        title_field: "Title",
        description_field: "Description",
        technologies_field: "Technologies",
        category_field: "Category",
        status_field: "Status",
        visibility_field: "Visibility",
        type_academic: "Academic project",
        type_professional: "Professional project",
        type_personal: "Personal project",
        live_url: "Project URL",
        github_url: "GitHub URL",
        image_url: "Project image",
        featured: "Featured project",
        published: "Published",
        draft: "Draft",
        archived: "Archived",
        save_success: "Project saved successfully",
        delete_success: "Project deleted successfully",
        delete_confirm: "Are you sure you want to delete this project?",
        add: "New project",
        images: "Manage images",
        gallery: "Image gallery",
        order: "Display order",
        tags: "Tags",
        seo: "SEO"
      },

      // Skills management
      skills: {
        title: "Skills management",
        list: "Skills list",
        add: "New skill",
        edit: "Edit skill",
        delete: "Delete skill",
        categories: "Categories",
        level: "Proficiency level",
        experience: "Years of experience",
        icon: "Icon",
        color: "Color",
        description: "Description",
        featured: "Main skill",
        order: "Display order"
      },

      // Upload and media
      upload: {
        title: "Media management",
        dragDrop: "Drag your images here or click to select",
        browse: "Browse files",
        formats: "Accepted formats: JPG, PNG, WebP, GIF",
        maxSize: "Maximum size: 10MB",
        uploading: "Uploading...",
        progress: "Progress",
        success: "Upload successful",
        error: "Upload error",
        delete_image: "Delete image",
        image_alt: "Alt text",
        image_title: "Image title",
        optimize: "Optimize image",
        resize: "Resize",
        crop: "Crop",
        gallery: "Gallery",
        library: "Media library"
      },

      // Forms
      form: {
        save: "Save",
        save_draft: "Save as draft",
        publish: "Publish",
        cancel: "Cancel",
        reset: "Reset",
        preview: "Preview",
        required: "Required",
        optional: "Optional",
        help_text: "Help text",
        char_count: "Character count",
        word_count: "Word count",
        auto_save: "Auto save",
        unsaved_changes: "Unsaved changes",
        validation_error: "Validation error",
        field_required: "This field is required",
        field_invalid: "This field contains invalid data"
      },

      // General actions
      actions: {
        create: "Create",
        read: "Read",
        update: "Update",
        delete: "Delete",
        duplicate: "Duplicate",
        archive: "Archive",
        restore: "Restore",
        export: "Export",
        import: "Import",
        backup: "Backup",
        sync: "Sync",
        refresh: "Refresh",
        search: "Search",
        filter: "Filter",
        sort: "Sort",
        bulk_actions: "Bulk actions",
        select_all: "Select all",
        deselect_all: "Deselect all"
      }
    },

    // ================================
    // COMMON / GENERAL
    // ================================
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      warning: "Warning",
      info: "Information",
      retry: "Retry",
      close: "Close",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      create: "Create",
      update: "Update",
      view: "View",
      search: "Search",
      filter: "Filter",
      sort: "Sort",
      confirm: "Confirm",
      yes: "Yes",
      no: "No",
      maybe: "Maybe",
      ok: "OK",
      done: "Done",
      continue: "Continue",
      back: "Back",
      forward: "Forward",
      home: "Home",
      settings: "Settings",
      help: "Help",
      about: "About",
      contact: "Contact",
      more: "More",
      less: "Less",
      all: "All",
      none: "None",
      other: "Other",
      unknown: "Unknown",
      not_available: "Not available",
      coming_soon: "Coming soon"
    },

    // ================================
    // COOKIES AND GDPR
    // ================================
    cookies: {
      banner: {
        title: "🍪 Miam, des cookies maison !",
        description: "Comme un bon pâtissier, j'ai préparé quelques cookies pour rendre votre visite plus agréable. À vous de choisir la recette !"
      },
      categories: {
        necessary: {
          title: "Cookies essentiels",
          description: "Ces cookies sont nécessaires au bon fonctionnement du site. Ils ne peuvent pas être désactivés."
        },
        analytics: {
          title: "Cookies d'analyse",
          description: "Ces cookies m'aident à comprendre comment vous utilisez le site, de manière totalement anonyme."
        },
        marketing: {
          title: "Cookies marketing",
          description: "Ces cookies permettent d'afficher des publicités pertinentes. Je ne les utilise pas actuellement."
        }
      },
      actions: {
        acceptAll: "Je goûte à tout ! 😋",
        rejectAll: "Pas faim merci ! 🙅‍♂️",
        customize: "Je choisis mes saveurs 🤔",
        acceptSelected: "C'est parfait ! 👌"
      },
      required: "Ingrédient de base",
      optional: "Garniture au choix",
      links: {
        privacy: "Les secrets du chef 🔒",
        policy: "La recette complète 📝"
      }
    },

    // ================================
    // PRIVACY POLICY
    // ================================
    privacy: {
      title: "🔐 Votre vie privée, ma priorité",
      subtitle: "Comment je protège vos données avec soin",
      lastUpdated: "Dernière mise à jour",
      required: "Nécessaire",
      optional: "Facultatif",
      toc: {
        title: "Au menu 📋"
      },
      sections: {
        introduction: {
          title: "👋 Bonjour !",
          content1: "Ici Jean-François, et je tiens à vous expliquer simplement comment je veille sur vos données quand vous visitez mon portfolio.",
          content2: "La transparence est ma devise : vous saurez exactement ce qui se passe avec vos informations.",
          highlight: "Votre confiance est précieuse ! Je ne collecte que les données vraiment utiles pour vous offrir la meilleure expérience possible. 🤝"
        },
        dataCollection: {
          title: "📱 Les données que je collecte",
          intro: "Je récolte les informations de deux façons :",
          automatic: {
            title: "Ce qui est automatique (comme les traces de pas)",
            ip: "Votre adresse IP et localisation approximative",
            browser: "Le type de navigateur que vous utilisez",
            device: "Votre type d'appareil",
            pages: "Les pages que vous visitez et le temps passé",
            duration: "La durée de votre visite et vos interactions"
          },
          voluntary: {
            title: "Ce que vous me confiez directement",
            name: "Votre nom (quand vous me contactez)",
            email: "Votre email (pour vous répondre)",
            message: "Vos messages (quand vous m'écrivez)",
            preferences: "Vos préférences (thème, cookies, etc.)"
          }
        },
        dataUsage: {
          title: "🎯 À quoi servent ces données ?",
          intro: "Voici comment j'utilise ces informations pour vous servir :",
          functionality: {
            title: "Pour que tout fonctionne bien",
            desc: "Garder vos préférences (thème sombre/clair, langue) pour votre confort"
          },
          communication: {
            title: "Pour discuter avec vous",
            desc: "Répondre à vos messages et rester en contact"
          },
          analytics: {
            title: "Pour m'améliorer",
            desc: "Comprendre comment vous utilisez le site et le rendre encore meilleur"
          },
          security: {
            title: "Pour votre sécurité",
            desc: "Protéger le site contre les mauvaises intentions et garder vos données en sécurité"
          }
        },
        cookies: {
          title: "🍪 Cookies",
          intro: "J'utilise différents types de cookies :",
          necessary: {
            title: "Cookies essentiels",
            desc: "Nécessaires au bon fonctionnement du site",
            consent: "Mémorise vos préférences de cookies",
            theme: "Se souvient de votre préférence de thème (sombre/clair)",
            language: "Se souvient de votre préférence de langue"
          },
          analytics: {
            title: "Cookies d'analyse",
            desc: "M'aident à comprendre l'utilisation du site avec Google Analytics"
          },
          marketing: {
            title: "Cookies marketing",
            desc: "Actuellement non utilisés sur ce site"
          }
        },
        dataSharing: {
          title: "🤝 Partage des données",
          noSharing: "Je ne vends, ne loue ni ne partage vos données personnelles avec des tiers à des fins commerciales.",
          content1: "Vos données ne sont partagées qu'avec les prestataires de confiance qui m'aident à faire fonctionner le site :",
          thirdParty: {
            title: "Services tiers",
            analytics: "Statistiques d'usage anonymes pour améliorer le site",
            hosting: "Hébergement sécurisé et livraison de contenu"
          }
        },
        dataSecurity: {
          title: "🛡️ Comment je protège vos données",
          intro: "Je ne plaisante pas avec la sécurité ! Voici mes mesures :",
          https: "Chiffrement HTTPS pour des échanges ultra-sécurisés",
          headers: "Protection contre les attaques malveillantes",
          rateLimit: "Limitation des requêtes pour éviter les abus",
          validation: "Vérification rigoureuse de toutes les entrées",
          monitoring: "Surveillance continue de la sécurité"
        },
        userRights: {
          title: "✨ Vos super-pouvoirs",
          intro: "Le RGPD vous donne des droits, utilisez-les !",
          access: {
            title: "Droit de regard",
            desc: "Vous pouvez voir toutes les données que j'ai sur vous"
          },
          rectification: {
            title: "Droit de correction",
            desc: "Une erreur ? Dites-le moi, je corrige !"
          },
          erasure: {
            title: "Droit à l'oubli",
            desc: "Vous voulez tout effacer ? Pas de problème !"
          },
          portability: {
            title: "Droit à la portabilité",
            desc: "Vos données vous appartiennent, emportez-les où vous voulez"
          }
        },
        contact: {
          title: "📬 Parlons-en !",
          intro: "Des questions sur vos données ou vos droits ? Je suis là !",
          email: "Mon email",
          response: "Délai de réponse",
          responseTime: "Je vous réponds sous 30 jours maximum (souvent bien plus vite 😉)",
          authority: {
            title: "Autorité de contrôle",
            desc: "Vous pouvez aussi contacter la CNIL si besoin :",
            link: "Contacter la CNIL (le gendarme des données en France)"
          }
        }
      }
    },

    // ================================
    // LEGAL NOTICES
    // ================================
    legal: {
      title: "Legal Notices",
      subtitle: "Legal information about this website",
      sections: {
        editor: {
          title: "Site Editor",
          name: "Name",
          status: "Status", 
          statusValue: "Individual / Freelance Developer",
          address: "Address",
          addressNote: "Exact address available upon request",
          contact: "Contact",
          website: "Website"
        },
        hosting: {
          title: "Hosting"
        },
        property: {
          title: "Intellectual Property",
          content1: "All content on this site (texts, images, code, design) is the property of Jean-François Chaussoy unless otherwise specified.",
          content2: "Any reproduction, even partial, is prohibited without prior written authorization.",
          exceptions: {
            title: "Exceptions",
            icons: "Icons: React Icons (MIT License)",
            fonts: "Fonts: Google Fonts (SIL Open Font License)",
            libraries: "JavaScript libraries: Various open source licenses",
            images: "Some images: Unsplash (Unsplash License)"
          }
        },
        responsibility: {
          title: "Responsibility",
          limitations: {
            title: "Limitation of Liability",
            content1: "The information on this site is provided 'as is' without warranty of any kind.",
            content2: "We cannot be held responsible for any direct or indirect damages resulting from the use of this site."
          },
          accuracy: {
            title: "Information Accuracy",
            content: "We strive to maintain accurate and up-to-date information, but we cannot guarantee its completeness or accuracy."
          },
          links: {
            title: "External Links",
            content: "This site may contain links to external websites. We are not responsible for the content or privacy practices of these sites."
          }
        },
        data: {
          title: "Personal Data",
          intro: "This site may collect the following personal data:",
          technical: {
            title: "Technical Data",
            logs: "Connection logs (IP, browser, pages visited)",
            analytics: "Anonymous usage statistics",
            preferences: "User preferences (theme, language)"
          },
          contact: {
            title: "Contact Data",
            name: "Name (if provided)",
            email: "Email address (if provided)",
            message: "Message content (if provided)"
          },
          gdpr: "For more information on data processing, see our",
          privacyPolicy: "Privacy Policy"
        },
        thirdParty: {
          title: "Third-party services used",
          intro: "This site uses the following third-party services:",
          emailjs: {
            name: "EmailJS",
            purpose: "Email sending service for contact form",
            website: "HTTPS://www.emailjs.com"
          },
          recaptcha: {
            name: "Google reCAPTCHA",
            purpose: "Protection against bots and spam",
            website: "HTTPS://www.google.com/recaptcha"
          }
        },
        applicable: {
          title: "Applicable Law",
          content1: "This site is governed by French law.",
          content2: "Any dispute will be subject to the jurisdiction of French courts.",
          jurisdiction: {
            title: "Jurisdiction",
            content: "In case of dispute, the courts of the publisher's domicile will have exclusive jurisdiction."
          }
        },
        contact: {
          title: "Contact",
          intro: "For any questions about these legal notices:",
          email: {
            title: "Email",
            response: "Response within 48 hours"
          },
          form: {
            title: "Contact Form",
            link: "Use the contact form",
            response: "Response within 24 hours"
          }
        }
      },
      footer: {
        lastUpdate: "Last update",
        privacy: "Privacy Policy",
        cookies: "Cookie Policy"
      }
    },

    // ================================
    // GENERAL navigation
    // ================================
    navigation: {
      home: "Home",
      about: "About",
      projects: "Projects",
      skills: "Skills",
      education: "Education",
      experience: "Experience",
      hobbies: "Hobbies",
      contact: "Contact",
      admin: "Administration",
      blog: "Blog",
      portfolio: "Portfolio",
      services: "Services",
      testimonials: "Testimonials",
      faq: "FAQ",
      legal: "Legal notices",
      privacy: "Privacy",
      sitemap: "Sitemap"
    },

    // ================================
    // MESSAGES AND NOTIFICATIONS
    // ================================
    messages: {
      success: "Operation successful",
      error: "An error occurred",
      warning: "Warning",
      info: "Information",
      confirm_delete: "Are you sure you want to delete this item?",
      confirm_action: "Are you sure you want to perform this action?",
      unsaved_changes: "You have unsaved changes",
      save_before_leave: "Do you want to save before leaving?",
      network_error: "Network connection error",
      server_error: "Server error",
      timeout_error: "Timeout error",
      unauthorized_access: "Unauthorized access",
      forbidden_access: "Forbidden access",
      not_found: "Item not found",
      session_expired: "Your session has expired",
      validation_error: "Data validation error",
      file_too_large: "File is too large",
      invalid_file_type: "File type not supported",
      upload_failed: "Upload failed",
      operation_cancelled: "Operation cancelled",
      no_internet: "No internet connection",
      maintenance_mode: "Site under maintenance",
      try_again_later: "Please try again later"
    },

    // ================================
    // FORMATS AND UNITS
    // ================================
    formats: {
      date: {
        short: "mm/dd/yyyy",
        long: "mmmm dd, yyyy",
        relative_now: "Just now",
        relative_minutes: "{{count}} minutes ago",
        relative_hours: "{{count}} hours ago",
        relative_days: "{{count}} days ago",
        relative_weeks: "{{count}} weeks ago",
        relative_months: "{{count}} months ago",
        relative_years: "{{count}} years ago"
      },
      file_size: {
        bytes: "bytes",
        kb: "KB",
        mb: "MB",
        gb: "GB",
        tb: "TB"
      },
      numbers: {
        thousand: "k",
        million: "M",
        billion: "B"
      }
    },

    // ================================
    // PRIVACY POLICY
    // ================================
    privacyPolicy: {
      title: "🔐 Your privacy, my priority",
      subtitle: "How I protect your data with care",
      lastUpdated: "Last updated",
      required: "Required",
      optional: "Optional",
      toc: {
        title: "Table of contents 📋"
      },
      sections: {
        introduction: {
          title: "👋 Hello!",
          content1: "Hi, I'm Jean-François, and I want to explain simply how I take care of your data when you visit my portfolio.",
          content2: "Transparency is my motto: you'll know exactly what happens with your information.",
          highlight: "Your trust is precious! I only collect data that's truly useful to offer you the best possible experience. 🤝"
        },
        dataCollection: {
          title: "📱 The data I collect",
          intro: "I gather information in two ways:",
          automatic: {
            title: "What's automatic (like footprints)",
            ip: "Your IP address and approximate location",
            browser: "The type of browser you use",
            device: "Your device type",
            pages: "The pages you visit and time spent",
            duration: "Your visit duration and interactions"
          },
          voluntary: {
            title: "What you share directly with me",
            name: "Your name (when you contact me)",
            email: "Your email (to respond to you)",
            message: "Your messages (when you write to me)",
            preferences: "Your preferences (theme, cookies, etc.)"
          }
        },
        dataUsage: {
          title: "🎯 What this data is used for?",
          intro: "Here's how I use this information to serve you:",
          functionality: {
            title: "To make everything work well",
            desc: "Keep your preferences (dark/light theme, language) for your comfort"
          },
          communication: {
            title: "To chat with you",
            desc: "Respond to your messages and stay in touch"
          },
          analytics: {
            title: "To improve myself",
            desc: "Understand how you use the site and make it even better"
          },
          security: {
            title: "For your security",
            desc: "Protect the site against bad intentions and keep your data safe"
          }
        },
        cookies: {
          title: "🍪 Cookies",
          intro: "I use different types of cookies:",
          necessary: {
            title: "Essential Cookies",
            desc: "Required for basic site functionality",
            consent: "Stores your cookie preferences",
            theme: "Remembers your theme preference (dark/light)",
            language: "Remembers your language preference"
          },
          analytics: {
            title: "Analytics Cookies",
            desc: "Help me understand site usage with Google Analytics"
          },
          marketing: {
            title: "Marketing Cookies",
            desc: "Currently not used on this site"
          }
        },
        dataSharing: {
          title: "🤝 Data Sharing",
          noSharing: "I do not sell, rent, or share your personal data with third parties for commercial purposes.",
          content1: "Your data is only shared with trusted service providers who help me operate the website:",
          thirdParty: {
            title: "Third-party Services",
            analytics: "Anonymous usage statistics for site improvement",
            hosting: "Secure hosting and content delivery (Hostinger VPS)",
            emailjs: "Email sending service via EmailJS for contact form",
            recaptcha: "Anti-spam protection via Google reCAPTCHA"
          }
        },
        dataSecurity: {
          title: "🛡️ How I protect your data",
          intro: "I don't mess around with security! Here are my measures:",
          https: "HTTPS encryption for ultra-secure exchanges",
          headers: "Protection against malicious attacks",
          rateLimit: "Request limiting to prevent abuse",
          validation: "Rigorous verification of all inputs",
          monitoring: "Continuous security monitoring"
        },
        userRights: {
          title: "✨ Your superpowers",
          intro: "GDPR gives you rights, use them!",
          access: {
            title: "Right to access",
            desc: "You can see all the data I have about you"
          },
          rectification: {
            title: "Right to correction",
            desc: "An error? Tell me, I'll fix it!"
          },
          erasure: {
            title: "Right to be forgotten",
            desc: "Want to delete everything? No problem!"
          },
          portability: {
            title: "Right to portability",
            desc: "Your data belongs to you, take it wherever you want"
          }
        },
        contact: {
          title: "📬 Let's talk!",
          intro: "Questions about your data or your rights? I'm here!",
          email: "My email",
          response: "Response time",
          responseTime: "I respond within 30 days maximum (often much faster 😉)",
          authority: {
            title: "Supervisory authority",
            desc: "You can also contact the CNIL if needed:",
            link: "Contact CNIL (the data police in France)"
          }
        }
      }
    },

    // ================================
    // SEO AND METADATA
    // ================================
    seo: {
      title: "Portfolio – Jean-François Chaussoy | Web Developer & Data Science",
      description: "Jean-François Chaussoy's portfolio, web developer specialized in React and Data Science.",
      keywords: "web developer,data science,React,full stack,portfolio,TypeScript,Node.js",
      jobTitle: "Full Stack Web Developer & Data Scientist",
      occupation: "Web Developer",
      og_title: "Portfolio Webcraft - Full Stack Developer",
      og_description: "Professional portfolio of a full stack developer and data scientist",
      og_type: "website",
      og_locale: "en_US",
      twitter_title: "Portfolio Webcraft",
      twitter_description: "Discover my projects and skills in web development and data science",
      twitter_card: "summary_large_image",
      canonical_url: "HTTPS://portfolio-webcraft.com",
      robots: "index, follow",
      language: "en",
      author: "Jean-François Chaussoy",
      copyright: "© 2024 Portfolio Webcraft"
    }
  }
};

export default translations;